// extracted by mini-css-extract-plugin
module.exports = {"description":"ModernCreativityInfoItem_description__ObiYK","button":"ModernCreativityInfoItem_button__9nKu4","category":"ModernCreativityInfoItem_category__Dd0z8"};